import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";

import { DffButtonModule, DffDateFieldModule, DffInfoModule, DffKvitteringModule, DffSideModule, PanelModule } from "@dffedb/ui";
import { MaalerAflaesningModule } from "@e-forsyning/common/maaler";

import { FlyttemeddelelseKvitteringComponent } from "./flyttemeddelelse-kvittering/flyttemeddelelse-kvittering.component";
import { FlyttemeddelelseRoutingModule } from "./flyttemeddelelse-routing.modul";
import { FlyttemeddelelseAflaesningComponent } from "./flyttemeddelelse/aflaesning/flyttemeddelelse-aflaesning.component";
import { FlyttemeddelelseAnmelderComponent } from "./flyttemeddelelse/anmelder/flyttemeddelelse-anmelder.component";
import { FlyttemeddelelseFakturaeringsadresseComponent } from "./flyttemeddelelse/faktureringsadresse/flyttemeddelelse-faktureringsadresse.component";
import { FlyttemeddelelseComponent } from "./flyttemeddelelse/flyttemeddelelse.component";
import { FlyttemeddelelseIndflytterComponent } from "./flyttemeddelelse/indflytter/flyttemeddelelse-indflytter.component";
import { FlyttemeddelelseUdbetalingComponent } from "./flyttemeddelelse/udbetaling/flyttemeddelelse-udbetaling.component";
import { FlyttemeddelelseUdflytterComponent } from "./flyttemeddelelse/udflytter/flyttemeddelelse-udflytter.component";

@NgModule({
    imports: [
        CommonModule,
        DffButtonModule,
        DffDateFieldModule,
        DffInfoModule,
        DffKvitteringModule,
        DffSideModule,
        MatButtonModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MaalerAflaesningModule,
        PanelModule,
        ReactiveFormsModule,
        FlyttemeddelelseRoutingModule
    ],
    declarations: [
        FlyttemeddelelseAflaesningComponent,
        FlyttemeddelelseKvitteringComponent,
        FlyttemeddelelseAnmelderComponent,
        FlyttemeddelelseComponent,
        FlyttemeddelelseFakturaeringsadresseComponent,
        FlyttemeddelelseIndflytterComponent,
        FlyttemeddelelseUdbetalingComponent,
        FlyttemeddelelseUdflytterComponent
    ]
})
export class EForsyningFeaturesFlyttemeddelelseModule {}
